import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

import { WIZARD_STEP_MIN_HEIGHT_CLASS } from '@/sections/attacks/attackPaths/components/wizards/constants';
import { cn } from '@/utils/classname';

import type { WizardStepContainerProps } from './types';

/**
 * Wrapper component for wizard steps that provides:
 * - Consistent minimum height across all wizard steps (prevents modal resizing)
 * - Enter/exit animations when stepping through the wizard
 *
 * The height enforcement ensures modals maintain consistent size
 * regardless of which step is displayed.
 */
export const WizardStepContainer: React.FC<WizardStepContainerProps> = ({
  children,
  animate = true,
  className,
}) => {
  const contentWrapper = (
    <div className={cn(WIZARD_STEP_MIN_HEIGHT_CLASS, className)}>
      {children}
    </div>
  );

  if (!animate) {
    return contentWrapper;
  }

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key="wizard-step"
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -20 }}
        transition={{ duration: 0.2 }}
      >
        {contentWrapper}
      </motion.div>
    </AnimatePresence>
  );
};
